import styles from "@/elements-react/cart-control-dropdown/css/cart-dropdown.module.scss";
import FixDropdownHead from "@/elements-react/fix-dropdown-head";
import FixIconIndicator from "@/elements-react/fix-icon-indicator";
import {CartDropdownProps} from "@/elements-react/cart-control-dropdown";
import React from "preact/compat";
export const CartDropdownDefault:React.FC<CartDropdownProps> = ({count, label, toCart}: CartDropdownProps) => {
    return (
        <div className={styles.host}>
            <FixDropdownHead icon="custom" label={label} onClick={toCart}>
                <FixIconIndicator slot="prefix" count={count} />
            </FixDropdownHead>
        </div>
    );
};